'use strict'
const queuedFuncCreator = require('../async/queuedFunc')
const queueProperty = Symbol('queuedThunkQueue')

exports.queuedThunkMiddleware = extra => {
  const queuedFunc = queuedFuncCreator()
  return ({ dispatch, getState }) => next => action => {
    if (typeof action !== 'function' || !action[queueProperty]) {
      return next(action)
    }
    const queueKey = action[queueProperty]

    return queuedFunc(() => action(dispatch, getState, extra), queueKey)
  }
}

exports.queueThunk = (thunkFunc, queueKey) => {
  const wrapperFunc = (...args) => thunkFunc(...args)
  wrapperFunc[queueProperty] = queueKey

  return wrapperFunc
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/redux/queuedThunk.js